import React from 'react';
import * as d3 from 'd3';

let nodes, root, force;

function collide(node) {
  let r = node.radius + 16,
    nx1 = node.x - r,
    nx2 = node.x + r,
    ny1 = node.y - r,
    ny2 = node.y + r;
  return function(quad, x1, y1, x2, y2) {
    if (quad.point && quad.point !== node) {
      let x = node.x - quad.point.x,
        y = node.y - quad.point.y,
        l = Math.sqrt(x * x + y * y),
        r = node.radius + quad.point.radius;
      if (l < r) {
        l = (l - r) / l * 0.5;
        node.x -= x *= l;
        node.y -= y *= l;
        quad.point.x += x;
        quad.point.y += y;
      }
    }
    return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
  };
}

class Graph extends React.Component {
  componentDidMount() {
    this.container = d3.select(this.refs.container);
    this.calculateData();
    this.startForce();
    this.renderGraph();
  }

  startForce() {
    force = d3.layout
      .force()
      .gravity(0.05)
      .charge((d, i) => i ? 0 : -2000)
      .nodes(nodes)
      .size([960, 500]);

    force.start();
    force.on(
      'tick',
      (e) => {
        let q = d3.geom.quadtree(nodes),
          i = 0,
          n = nodes.length;

        while (++i < n) q.visit(collide(nodes[i]));

        this.container
          .selectAll("circle")
          .attr("cx", function (d) {
            return d.x;
          })
          .attr("cy", function (d) {
            return d.y;
          });
      }
    );
  }

  renderGraph() {
    const colors = [
      'rgba(230, 126, 105, 1)',
      'rgba(230, 126, 105, 0.6)',
      'rgba(230, 126, 105, 0.4)',
      'rgba(239, 175, 164, 1)',
      'rgba(239, 175, 164, 0.6)',
      'rgba(239, 175, 164, 0.4)',
      'rgba(0, 178, 166, 1)',
      'rgba(0, 178, 166, 0.6)',
      'rgba(0, 178, 166, 0.4)',
      'rgba(239, 202, 117, 1)',
      'rgba(239, 202, 117, 0.6)',
      'rgba(239, 202, 117, 0.4)',
      'rgba(229, 168, 38, 1)',
      'rgba(229, 168, 38, 0.6)',
      'rgba(229, 168, 38, 0.4)'
    ];
    this.container
      .selectAll('circle')
      .data(nodes.slice(1))
      .enter()
      .append('circle')
      .attr('r', function(d) {
        return d.radius;
      })
      .style('fill', function(d, i) {
        return colors[i % 15];
      });

    this.container.on('mousemove', function() {
      const p1 = d3.mouse(this);
      root.px = p1[0];
      root.py = p1[1];
      force.resume();
    });

    this.container.on('touchmove', function() {
      const p1 = d3.mouse(this);
      root.px = p1[0];
      root.py = p1[1];
      force.resume();
    });
  }

  calculateData() {
    nodes = d3.range(200).map(() => {
      return {
        radius: Math.random() * 12 + 4
      };
    });
    root = nodes[0];
    root.radius = 0;
    root.fixed = true;
  }
  render() {
    return <g ref="container" />;
  }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/routes/landing/Graph.js